<template>
    <base-dialog :loading="loading" :value="dialog" :title="title" :width="500" @input="onDialogInput" @close="hide">
        <kimsa-combobox :label="$t('common.coaches')" :placeholder="$t('common.select')" dense :items="coaches"
            @change="currentCoach = $event" :value="currentCoach" ref="coaches" />
        <template #footer>
            <v-btn class="footer-btn" depressed block :disabled="disabled" @click="save" :loading="loading">
                {{ $t('common.share') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { db, Timestamp } from "@/utils/Firebase";
import BaseDialog from "@/components/common/BaseDialog";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";

export default {
    name: "ShareEntityDialog",
    components: { BaseDialog, KimsaCombobox },
    props: {
        title: {
            type: String,
            default: '',
        },
        collection: {
            type: String,
            required: true,
        },
        sharedToast: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            entity: null,
            coaches: [],
            currentCoach: null,
        }
    },
    computed: {
        disabled(vm = this) {
            return !vm.currentCoach
        },
        companyId(vm = this) {
            return vm.isCompany ? vm.currentUser.uid : vm.account?.coachSubscription?.companyId
        }
    },
    methods: {
        ...mapActions(['fetchCompanyCoaches']),
        show(entity) {
            const vm = this
            vm.entity = entity
            vm.dialog = true
            vm.loadCoaches()
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        onDialogInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.entity = null
            vm.currentCoach = null
        },
        async loadCoaches() {
            const vm = this
            const coaches = await vm.fetchCompanyCoaches(vm.companyId)
            vm.coaches = coaches.map(hit => ({ ...hit, name: hit.name || hit.email })).filter(hit => hit.objectID !== vm.entity?.coachId)
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                const currentRef = await db.collection(vm.collection).doc(vm.entity.objectID).get()
                const current = currentRef.data()

                let payload = {
                    ...current,
                    coachId: vm.currentCoach.objectID,
                    created_at: Timestamp.now(),
                    shared: true,
                    name: `${current.name} (${vm.$t('common.shared')})`,
                }

                delete payload._highlightResult
                delete payload.objectID

                await db.collection(vm.collection).add(payload)

                vm.hide()
                if (vm.sharedToast) vm.toast(vm.sharedToast)
            })
        },
    },
}
</script>

<style scoped>
.footer-btn.v-btn {
    height: 52px !important;
    border-radius: 0 !important;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 700;
    box-shadow: none !important;
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}

.footer-btn.v-btn.v-btn--disabled {
    background: var(--v-surface2-base) !important;
    color: var(--v-txtMuted-base) !important;
}
</style>
